// extracted by mini-css-extract-plugin
export default {"Wizard":"Wizard_Wizard__-j0pm","Pages":"Wizard_Pages__xS2O8","PagesCont":"Wizard_PagesCont__lpo4m","Step":"Wizard_Step__djyO0"};